import { FC } from 'react';
import { cx } from '@emotion/css';

import { OverviewHeadline } from './overview-headline';

export interface OverviewSectionProps {
  headline?: string;
  subHeadline?: string;
  dataTestId?: string;
  className?: string;
  isWide?: boolean;
}

export const OverviewSection: FC<React.PropsWithChildren<OverviewSectionProps>> = ({
  headline,
  subHeadline,
  className,
  children,
  dataTestId = 'dashboardSection',
}) => {
  return (
    <section aria-label={headline} className={cx('select-none stihl-page-container hover:select-text', className)} data-testid={dataTestId}>
      {headline && <OverviewHeadline headline={headline} />}
      {subHeadline && <p className="mt-2 max-w-2xl stihl-text-body-default-reg">{subHeadline}</p>}
      {children}
    </section>
  );
};
